import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";

@Component({
  selector: "search-input-row",
  templateUrl: "./search-input-row.component.html",
  styleUrls: ["./search-input-row.component.css"],
})
export class SearchInputRowComponent {
  @Input() public searchVar: string;
  @Input() public disableAddition: boolean = false;
  @Input() public nameIsRequiredForAdd: boolean;
  @Input() public placeholderText = "general.search";
  @Input() public bottomSpacing: boolean = true;
  @Input() public roundedCorners: boolean = true;
  @Output() public onAdd = new EventEmitter();
  @Output() public onSearchVarUpdate = new EventEmitter();
  @ViewChild("searchInputForm") public searchInputForm;

  public callAddEvent(searchVar) {
    if (this.nameIsRequiredForAdd) {
      if (searchVar && searchVar !== "") {
        this.onAdd.emit(searchVar);
      }
    } else {
      this.onAdd.emit(searchVar);
    }
  }
}
